import Luiv3Constants from '@app/lui3/constants';
import {IconName, IconStyle} from '@fortawesome/fontawesome-common-types';
import {
  FlipProp,
  RotateProp,
  SizeProp,
} from '@fortawesome/fontawesome-svg-core';
import {ComponentProps} from 'react';
import styled from 'styled-components';

export const FA_BRAND_ICONS = ['chrome'];

export type CustomIconName =
  | 'custom-checklist-regular'
  | 'custom-phone-lines-regular'
  | 'custom-sidebar-regular'
  | 'custom-user-group-regular'
  | 'custom-building-plus-solid'
  | 'custom-bullhorn-solid'
  | 'custom-checklist-solid'
  | 'custom-list-clock-solid'
  | 'custom-presentation-screen-user-solid'
  | 'custom-user-group-solid'
  | 'custom-search-sparkles-solid'
  | 'custom-pen-sparkles-solid'
  | 'custom-arrow-rotate-left-user-regular'
  | 'custom-arrow-rotate-right-user-regular'
  | 'custom-calendar-regular'
  | 'custom-calendar-solid'
  | 'custom-google-chrome-regular'
  | 'custom-font-color-solid'
  | 'custom-envelope-sparkles-regular'
  | 'custom-envelope-sparkles-solid'
  | 'custom-phone-sparkles-regular'
  | 'custom-phone-sparkles-solid'
  | 'custom-user-sparkles-regular'
  | 'custom-clock-lock-solid'
  | 'custom-ranking-sparkles-solid';

type CustomSizeProp = 'custom-md';

interface Props extends ComponentProps<typeof StyledIcon> {
  faStyle?: 'kit' | IconStyle;
  icon: IconName | CustomIconName;
  size?: SizeProp | CustomSizeProp;
  className?: string;
  flip?: FlipProp;
  rotate?: RotateProp;
  color?: keyof typeof Luiv3Constants.baseColor;
}

const StyledIcon = styled.i<{color?: keyof typeof Luiv3Constants.baseColor}>`
  display: inline-block;
  ${({color}) => color && `color: ${Luiv3Constants.baseColor[color]};`}

  /* Custom size: 1.143em (16/14 ratio) */
  &.fa-custom-md {
    font-size: 1.143em;
  }
`;

const FaIcon = ({
  faStyle = 'regular',
  icon,
  size = 'custom-md',
  className,
  flip,
  rotate,
  color,
  ...props
}: Props) => {
  // Custom icons must use style "kit"
  if (icon.startsWith('custom-') && faStyle !== 'kit') {
    faStyle = 'kit';
  }
  const iconClasses = [
    `fa-${faStyle}`,
    `fa-${icon}`,
    `fa-${size}`,
    flip && `fa-flip-${flip}`,
    rotate && `fa-rotate-${rotate}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return <StyledIcon className={iconClasses} color={color} {...props} />;
};

export default FaIcon;
